import * as yup from "yup";
import {
  emailValidation,
  passwordValidation,
  maxLengthValidation,
} from "src/utils/validation";

// 회원가입 폼 데이터 타입
export interface JoinFormData {
  userId: string;
  userName: string;
  companyName: string;
  password: string;
  passwordCheck: string;
  token: string;
  termsAgreed: boolean;
  privacyAgreed: boolean;
}

// 회원가입 스키마
export const joinSchema = yup.object().shape({
  userId: yup
    .string()
    .required("logIn.enterUserEmail")
    .test(
      "email-validation",
      "logIn.signUp.invalidEmailFormat",
      emailValidation
    )
    .test("max-length", "이메일은 50자 이하여야 합니다.", (value) =>
      maxLengthValidation(value, 50)
    ),

  userName: yup
    .string()
    .required("logIn.enterName")
    .test("max-length", "이름은 50자 이하여야 합니다.", (value) =>
      maxLengthValidation(value, 50)
    ),

  companyName: yup
    .string()
    .required("logIn.enterCompanyName")
    .test("max-length", "회사명은 50자 이하여야 합니다.", (value) =>
      maxLengthValidation(value, 50)
    ),

  password: yup
    .string()
    .required("logIn.enterPassword")
    .test(
      "password-validation",
      "logIn.signUp.invalidPasswordFormat",
      passwordValidation
    ),

  passwordCheck: yup
    .string()
    .required("logIn.enterPassword")
    .oneOf([yup.ref("password")], "logIn.signUp.invalidPassword"),

  token: yup.string().required("admin.login.otp.enterMsgAdmin"),
  termsAgreed: yup
    .boolean()
    .oneOf([true], "logIn.signUp.requiredAgreement")
    .required("logIn.signUp.requiredAgreement"),

  privacyAgreed: yup
    .boolean()
    .oneOf([true], "logIn.signUp.requiredPrivacy")
    .required("logIn.signUp.requiredPrivacy"),
});
